module.exports = __webpack_public_path__ + "img/note.062392bc.svg";